<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
     style="background: #f6f9fa;"
     (keydown.enter)="submit($event)">
  <div>
    <div class="auth-box">
      <div class="logo">
        <span class="db">
          <img src="assets/images/logo-dark-blue.svg" alt="logo" style="max-height: 200px; max-width:100%;" />
        </span>
        <h5 class="font-medium m-b-20">{{ 'passwordRecovery.title' | translate }}</h5>
        <span>{{ 'passwordRecovery.description' | translate }}</span>
      </div>

      <div *ngIf="message" class="alert" [ngClass]="{'alert-success': messageType === 'success', 'alert-danger': messageType === 'error'}">
        {{ message }}
      </div>

      <form class="form-horizontal m-t-20" (submit)="submit($event)">
        <div class="input-group mb-3">
          <div class="input-group-text"><i class="ti-user"></i></div>
          <input
            type="email"
            class="form-control form-control-lg"
            [(ngModel)]="email"
            name="email"
            [placeholder]="'passwordRecovery.emailPlaceholder' | translate"
            [attr.aria-label]="'passwordRecovery.emailPlaceholder' | translate"
            aria-describedby="basic-addon1"
            [disabled]="isLoading">
        </div>

        <div class="form-group text-center">
          <div class="col-xs-12 p-b-20">
            <button class="btn btn-block btn-lg btn-info" type="submit" [disabled]="isLoading">
              {{ isLoading ? ('passwordRecovery.submitting' | translate) : ('passwordRecovery.submit' | translate) }}
            </button>
          </div>
          <div class="col-xs-12">
            <a href="#" (click)="goBack($event)">{{ 'passwordRecovery.backToLogin' | translate }}</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<footer class="footer">
  <app-custom-footer></app-custom-footer>
</footer>
